import type { LocalShift, LocalShiftType } from '@wolhasudang/shared';

/** One presentation owner for saved actual clocks and their explicit planned fallback. */
export function shiftRecordFacts(shift: LocalShift, type?: LocalShiftType) {
  const scheduledStart = shift.scheduledStart ?? type?.start ?? '';
  const scheduledEnd = shift.scheduledEnd ?? type?.end ?? '';
  const actualStart = shift.actualStart ?? '';
  const actualEnd = shift.actualEnd ?? '';
  const actualConfirmed = shift.actualConfirmed && Boolean(actualStart && actualEnd);
  const start = actualConfirmed ? actualStart : scheduledStart, end = actualConfirmed ? actualEnd : scheduledEnd;
  const breakMinutes = shift.actualBreakUnconfirmed ? undefined : shift.actualBreakMinutes;
  return {
    scheduledStart, scheduledEnd, actualStart, actualEnd, actualConfirmed, breakMinutes,
    time: type?.kind === 'off' ? '근무 없음' : start && end ? `${start}–${end}` : '근무 시각 확인 필요',
    breakText: breakMinutes === undefined ? '실제 휴게 확인 필요' : `실제 휴게 ${breakMinutes}분`,
  };
}
